import alerts from './alerts.json';
import appBanner from './appBanner.json';
import auth from './auth.json';
import cancelJob from './cancelJob.json';
import chat from './chat.json';
import common from './common.json';
import hire from './hire.json';
import jobDetail from './jobDetail.json';
import jobs from './jobs.json';
import map from './map.json';
import nav from './nav.json';
import notifications from './notifications.json';
import pageTitle from './pageTitle.json';
import payments from './payments.json';
import profile from './profile.json';
import rating from './rating.json';
import ratingDetail from './ratingDetail.json';
import report from './report.json';
import settings from './settings.json';
import shell from './shell.json';
import supportForm from './supportForm.json';
import termsSections from './termsSections.json';
import theme from './theme.json';
import validation from './validation.json';

/** Merged English catalog — prefer editing domain files under `translations/en/`. */
const en = {
  common,
  appBanner,
  alerts,
  validation,
  auth,
  nav,
  shell,
  pageTitle,
  jobDetail,
  ratingDetail,
  rating,
  report,
  cancelJob,
  hire,
  jobs,
  profile,
  payments,
  notifications,
  supportForm,
  chat,
  map,
  settings,
  theme,
  termsSections,
};

export default en;
